module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ThinItalic.13f31b20.eot";